export default __webpack_public_path__ + "static/media/lock.d68bd22b.png";